import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Grid, CircularProgress, FormControlLabel, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SeminarAttendanceFormDialog({ open, onClose, attendance, seminars, academics, onSave, saving }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({ seminar: "", academic: "", attended: false, notes: "" });

  useEffect(() => {
    if (attendance) {
      setForm({
        seminar: attendance.seminar || "",
        academic: attendance.academic || "",
        attended: !!attendance.attended,
        notes: attendance.notes || "",
      });
    } else {
      setForm({ seminar: "", academic: "", attended: false, notes: "" });
    }
  }, [attendance, open]);

  const handleChange = (e) => { const { name, value, type, checked } = e.target; setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value })); };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      seminar: form.seminar ? Number(form.seminar) : null,
      academic: form.academic ? Number(form.academic) : null,
      attended: form.attended,
      notes: form.notes || "",
    });
  };

  const seminarList = seminars?.results || seminars || [];
  const academicList = academics?.results || academics || [];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{attendance ? t("academic.editAttendance", "Edit Attendance") : t("academic.addAttendance", "Add Attendance")}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <TextField fullWidth required name="seminar" select label={t("academic.seminar", "Seminar")} value={form.seminar} onChange={handleChange} size="small">
                <MenuItem value="">—</MenuItem>
                {seminarList.map((s) => <MenuItem key={s.id} value={s.id}>{s.title} ({s.seminar_date})</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth required name="academic" select label={t("academic.trainee", "Trainee")} value={form.academic} onChange={handleChange} size="small">
                <MenuItem value="">—</MenuItem>
                {academicList.map((a) => <MenuItem key={a.id} value={a.id}>{a.name_display || `${a.first_name || ""} ${a.last_name || ""}`.trim() || a.id}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12}><FormControlLabel control={<Checkbox name="attended" checked={form.attended} onChange={handleChange} />} label={t("academic.attended", "Attended")} /></Grid>
            <Grid item xs={12}><TextField fullWidth name="notes" label={t("academic.notes", "Notes")} value={form.notes} onChange={handleChange} multiline rows={2} size="small" /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions><Button onClick={onClose}>{t("common.cancel", "Cancel")}</Button><Button type="submit" variant="contained" disabled={saving || !form.seminar || !form.academic}>{saving ? <CircularProgress size={24} /> : t("common.save", "Save")}</Button></DialogActions>
      </form>
    </Dialog>
  );
}
